<template>
    <div class="ct-box">
        <div class="setting">
            <div class="mark">
                <label>标识</label>
                <input type="text" class="clearfix" name="markName" v-model="siteDetail.id" id="markId" readonly>
            </div>
            <div class="customer clearfix">
                <label style="float:left;margin-left:111px;margin-top: 5px;" for="">顾客名称</label>
                <input type="text" class="droplist" v-model="siteDetail.company" readonly>
                <span class="warning"><i>*</i> 为必填项</span>
            </div>

            <div class="customer clearfix">
                <label style="float:left;margin-left:96px;margin-top: 5px;" for="">服务器名称</label>
                <select class="droplist" v-model="siteDetail.server_id">
                    <option v-bind:value="server.guid" v-for="server in siteDetail.servers">{{server.server_name}}</option>
                    <b></b>
                </select>
                <span class="warning"><i>*</i> 服务器选定后,将禁止修改</span>
            </div>

            <div class="domain"  style="margin-top:40px;">
                <label for="">站点名称</label>
                <div class="clearfix">
                    <input type="text" placeholder="例： 我的ERP站" v-model="siteDetail.site_name">
                </div>
                <p>为站点命名</p>
            </div>

            <div class="domain">
                <label for="">绑定域名</label>
                <div class="clearfix">
                    <input type="text" placeholder="例： www.demo.com www.demo1.com" v-model="siteDetail.domains">
                </div>
                <p style="color:red">*不配置即使用系统生成的域名, 也可以在这里绑定更多域名,域名间用空格隔开</p>
            </div>


            <!--<div class="domain">
                <label for="">并发限制</label>
                <div class="clearfix">
                    <input type="text">
                </div>
                <p>默认开发限制为300个链接</p>
            </div>-->

            <div class="subbtn" v-on:click="btnSubmit">
                <span>提交数据</span>
            </div>

        </div>
    </div>
</template>

<script>
    import cookie from 'vue-cookie'

    export default {
        name: "SiteConfig",
        beforeRouteEnter(to, from, next) {
            if (cookie.get('erp_tk') && cookie.get('erp_st') === '2') {
                next(true)
            } else {
                next({path: '/client', query: {redirect: to.fullPath}})
            }
        },
        data() {
            return {
                demo:'',
                apiDomain: 'http://wechat.lixun365.com',
                siteDetail: {id: '', site_name: '', server_id: '', client_id: '', company: '', domains: '', servers: [{guid: '', server_name: '', server_number: ''}]},
            }
        },
        created: function () {
            this.$axios.get(this.apiDomain + '/api/site.site/sitedetail', {params: {ticket: this.$cookie.get('erp_tk')}})
                .then(res => {
                    if (res.data.code === 1001) {
                        this.siteDetail = res.data.data
                        this.servers = res.data.data.servers
                        this.siteDetail.server_id = res.data.data.servers[0].guid
                    } else {
                        layer.msg(res.data.msg)
                    }
                }).catch(err => {
                console.log(err)
            })

        },
        methods: {
            btnSubmit: function () {
                var sendData = $.extend(true, {}, this.siteDetail)
                delete sendData.company; delete sendData.servers
                sendData.ticket = this.$cookie.get('erp_tk')

                this.siteDetail.ticket = this.$cookie.get('erp_tk')

                this.$axios.post(this.apiDomain + '/api/site.site/sitedetail', sendData)
                    .then(res => {
                        if(res.data.code === 1001) {
                            this.$cookie.set('erp_tk', res.data.data.ticket, '1D')
                            this.$cookie.set('erp_st', res.data.data.step, '1D')
                            this.$router.push({name: 'payMeal'})
                        }
                        layer.msg(res.data.msg)
                    }).catch(err => { layer.msg(err)})
            }
        },
    }
</script>

<style scoped>
    .mark {
        text-align: left;
        margin-left: 142px;
    }
    #markId {
        width: 665px;
        height: 34px;
        margin-left: 22px;
    }
</style>